<template>
  <div>
    <el-upload
      class="image-uploader"
      :class="{ 'hide-uploader': fileList.length >= limit }"
      action=""
      list-type="picture-card"
      :file-list.sync="fileList"
      :limit="limit"
      multiple
      :http-request="customUpload"
      :on-success="handleSuccess"
      :on-remove="handleRemove"
      :before-upload="beforeUpload"
      :on-preview="handlePreview"
    >
      <i class="el-icon-plus"></i>
    </el-upload>

    <el-dialog :visible.sync="dialogVisible" append-to-body width="60%">
      <div class="dlg-content">
        <img :src="previewImageUrl" alt="预览图片" style="width: 100%" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadfile } from '@/api'

export default {
  name: 'ImageUploadMultiple',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    limit: {
      type: Number,
      default: 99,
    },
  },
  data() {
    return {
      fileList: this.value.map((item, index) => ({
        name: `图片${index + 1}`,
        url: item?.url,
      })),
      dialogVisible: false,
      previewImageUrl: '',
    }
  },
  watch: {
    value: {
      handler(newVal) {
        // 如果 fileList 和 value 长度不同才更新（防止频繁渲染）
        if (newVal.length !== this.fileList.length) {
          this.fileList = newVal.map((item, index) => ({
            name: `图片${index + 1}`,
            url: item?.url,
          }))
        }
      },
      immediate: true,
    },
  },
  methods: {
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isImage) {
        this.$message.error('只能上传图片文件！')
        return false
      }
      if (!isLt10M) {
        this.$message.error('图片大小不能超过 10MB！')
        return false
      }
      return true
    },

    // 自定义上传方法
    async customUpload({ file, onSuccess, onError }) {
      const formData = new FormData()
      formData.append('file', file)

      try {
        const url = await uploadfile(formData)
        file.url = url
        onSuccess({ url })
      } catch (err) {
        onError(err)
        this.$message.error('上传失败')
      }
    },

    handleSuccess(response, file, fileList) {
      file.url = response.url

      const exist = this.fileList.find(item => item.uid === file.uid)
      if (!exist) {
        this.fileList.push({
          name: file.name,
          url: file.url,
          uid: file.uid,
        })
      } else {
        exist.url = file.url
      }

      this.$emit('input', this.fileList)
    },
    handleRemove(file, fileList) {
      const index = this.fileList.findIndex(item => item.uid === file.uid)
      if (index !== -1) {
        this.fileList.splice(index, 1)
      }

      this.$emit('input', [...this.fileList])
    },
    handlePreview(file) {
      this.previewImageUrl = file.url
      this.dialogVisible = true
    },
  },
}
</script>

<style lang="less">
.hide-uploader {
  .el-upload {
    display: none;
  }
}
</style>
<style scoped lang="less">
.image-uploader ::v-deep .el-upload {
  width: 148px;
  height: 148px;
}

.dlg-content {
  height: calc(100vh - 300px);
  overflow: auto;
}
</style>
